import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useSettingStore = defineStore(
    'setting',
    () => {
        const large = ref(true)

        return {
            large,
        }
    },
    {
        persist: true
    }
)
